import React from 'react';
import { useTranslations } from 'next-intl';

import { Button, FormControl } from '@zealy/design-system';

export const Domino = () => {
  const t = useTranslations('quest.type.onChain.fields.domino');

  return (
    <FormControl name="domino" label={t('label')}>
      <div className="flex gap-100">
        <Button
          variant="muted"
          onClick={() => {
            window.open('https://domino.run/explore/templates/99', '_blank', 'noopener noreferrer');
          }}
        >
          {t('type.logs')}
        </Button>
        <Button
          variant="muted"
          onClick={() => {
            window.open('https://domino.run/explore/templates/98', '_blank', 'noopener noreferrer');
          }}
        >
          {t('type.state')}
        </Button>
      </div>
    </FormControl>
  );
};
